export default __webpack_public_path__ + "static/media/gillassoc_header.007ae05b.jpg";